import type { UserWorkspace } from '@/api/types'
import { useWorkspaces } from './queries'
import { tenantWorkspace } from './selection'

export interface TenantWorkspace {
  workspace: UserWorkspace | undefined
  isPending: boolean
}

/** The workspace the shell is showing. See `tenantWorkspace` for which one that is. */
export function useTenantWorkspace(): TenantWorkspace {
  const { data, isPending } = useWorkspaces()

  return { workspace: tenantWorkspace(data ?? []), isPending }
}
